import { render, staticRenderFns } from "./EventParticipantSetting.vue?vue&type=template&id=2e74193a"
import script from "./EventParticipantSetting.vue?vue&type=script&lang=js"
export * from "./EventParticipantSetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports